export interface TenantPlusUpsellModalTranslations {
  header: string;
  benefits: Record<string, string>;
  benefitCaption: string;
  startFreeTrialCTA: string;
  learnMoreCTA: string;
  alreadyTenantPlusUserCTA: string;
}

export const buildTenantPlusUpsellBenefitsRecord = (
  t: (key: string) => string,
  benefitTranslationKeys: string[],
): Record<string, string> =>
  Object.fromEntries(benefitTranslationKeys.map((key, index) => [`benefit${index + 1}`, t(key)]));

export const buildTenantPlusUpsellTranslations = (
  t: (key: string) => string,
  {
    headerKey,
    benefitTranslationKeys,
    benefitCaption = '',
    startFreeTrialCTAKey,
    learnMoreCTAKey,
    alreadyTenantPlusUserCTAKey,
  }: {
    headerKey: string;
    benefitTranslationKeys: string[];
    benefitCaption?: string;
    startFreeTrialCTAKey: string;
    learnMoreCTAKey: string;
    alreadyTenantPlusUserCTAKey: string;
  },
): TenantPlusUpsellModalTranslations => ({
  header: t(headerKey),
  benefits: buildTenantPlusUpsellBenefitsRecord(t, benefitTranslationKeys),
  benefitCaption,
  startFreeTrialCTA: t(startFreeTrialCTAKey),
  learnMoreCTA: t(learnMoreCTAKey),
  alreadyTenantPlusUserCTA: t(alreadyTenantPlusUserCTAKey),
});
